import { render, staticRenderFns } from "./CourseListDataIteratorContent.vue?vue&type=template&id=765fde8d&scoped=true&"
import script from "./CourseListDataIteratorContent.vue?vue&type=script&lang=js&"
export * from "./CourseListDataIteratorContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765fde8d",
  null
  
)

export default component.exports